import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=21ba3a83&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=21ba3a83&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba3a83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ba3a83')) {
      api.createRecord('21ba3a83', component.options)
    } else {
      api.reload('21ba3a83', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=21ba3a83&scoped=true", function () {
      api.rerender('21ba3a83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/contact.vue"
export default component.exports